import Color from '@src/utils/color';
import { generate } from '@arco-design/color';
export var getHex = function getHex(value) {
  var resValue;
  try {
    resValue = Color(value);
    var rgb = resValue.object();
    if (rgb.alpha !== 1 && rgb.alpha !== undefined) {
      return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.alpha + ")";
    }
  } catch (_) {
    console.error('select color error: ', _);
    return '';
  }
  return resValue.hex().toString();
};
export var getHexValue = function getHexValue(_value, presetColors) {
  var value;
  Object.values(presetColors.light).concat(Object.values(presetColors.dark)).some(function (_a) {
    var list = _a.list;
    return list.some(function (item) {
      if (item.key === _value) {
        value = item.value;
        return true;
      }
    });
  });
  if (!value) {
    try {
      value = getHex(_value);
    } catch (_) {
      value = _value;
    }
  }
  return value || _value;
};
export var getRgb = function getRgb(value) {
  var resValue;
  try {
    resValue = Color(value);
  } catch (_) {
    console.error('select color error: ', value, _);
    return '';
  }
  var rgb = resValue.object();
  if (rgb.alpha !== 1 && rgb.alpha !== undefined) {
    return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.alpha + ")";
  }
  return resValue.rgb().toString();
};
export function genSingleColor(_key, color) {
  var result = color;
  var tokens = {};
  var key = _key;
  if (_key === 'brand') {
    key = 'primary';
  }
  if (color) {
    var item = getRgb(color);
    result = item;
    tokens[key] = {
      key: key,
      value: item,
      component: 'Color'
    };
  }
  return {
    color: result,
    tokens: tokens
  };
}
export function genSeriesColor(_key, presetKey, color) {
  var colorSeries = {};
  var tokens = {};
  var key = _key;
  if (_key === 'brand') {
    key = 'primary';
  }
  if (presetKey) {
    for (var i = 1; i < 11; i++) {
      colorSeries["@" + key + "-" + i] = {
        light: "@" + presetKey + "-" + i,
        dark: "@dark-" + presetKey + "-" + i
      };
      tokens["@" + key + "-" + i] = {
        key: "@" + key + "-" + i,
        value: "rgb(var(--" + presetKey + "-" + i + "))",
        component: 'Color'
      };
      tokens["@dark-" + key + "-" + i] = {
        key: "@dark-" + key + "-" + i,
        value: "rgb(var(--" + presetKey + "-" + i + "))",
        component: 'Color'
      };
    }
  } else if (color) {
    var lightList = generate(color, {
      list: true
    });
    var darkList_1 = generate(color, {
      list: true,
      dark: true
    });
    lightList.forEach(function (hex, index) {
      var item = getRgb(hex);
      colorSeries["@" + key + "-" + (index + 1)] = {
        light: item,
        dark: getRgb(darkList_1[index])
      };
      tokens["@" + key + "-" + (index + 1)] = {
        key: "@" + key + "-" + (index + 1),
        value: item,
        component: 'Color'
      };
      tokens["@dark-" + key + "-" + (index + 1)] = {
        key: "@dark-" + key + "-" + (index + 1),
        value: getRgb(darkList_1[index]),
        component: 'Color'
      };
    });
  }
  return {
    colorSeries: colorSeries,
    tokens: tokens
  };
}
export var failContrast = function failContrast(background) {
  var backgroundObj = Color(background);
  var frontObj = Color('#ffffff');
  var contrast = backgroundObj.contrast(frontObj).toFixed(2);
  return Number(contrast) < 1.5;
};